// extracted by mini-css-extract-plugin
module.exports = {"featurePackCell":"FeaturePackCell_featurePackCell__lonIj","text":"FeaturePackCell_text__XivnQ","bold":"FeaturePackCell_bold__1492d"};